import { render, staticRenderFns } from "./nombre-documento.vue?vue&type=template&id=8b50002c"
import script from "./nombre-documento.vue?vue&type=script&lang=js"
export * from "./nombre-documento.vue?vue&type=script&lang=js"
import style0 from "./nombre-documento.vue?vue&type=style&index=0&id=8b50002c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports